module.exports = __webpack_public_path__ + "img/img.6c24f45d.svg";